import * as React from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import PropTypes from "prop-types";

import WevoLogo from "../WevoLogo";
import WevoIcon from "../WevoIcon";

import styles from "../../styles/components/AppHeader.css";
import UserAccountMenu from "./UserAccountMenu";
import Truncated from "../Truncated";
import Config from "../../config";

export default class AppHeader extends React.PureComponent {
    render() {
        const headerClass = [
            styles.appHeader,
            this.props.isAuthenticated || this.props.isShareLink
                ? styles.authenticated
                : styles.unauthenticated
        ].join(" ");
        const logoClass = [
            styles.wevoHeaderLogo,
            this.props.pageTitle ? styles.wevoIcon : styles.wevoLogo
        ].join(" ");
        return (
            <div className={headerClass}>
                <Link to={this.props.logoLink} className={logoClass}>
                    {this.props.pageTitle ? <WevoIcon /> : <WevoLogo />}
                </Link>
                {(this.props.isAuthenticated || this.props.isShareLink) && (
                    <div className={styles.pageTitle}>
                        {this.props.pageTitleIcon && (
                            <Icon
                                className={styles.pageTitleIcon}
                                size="lg"
                                icon={this.props.pageTitleIcon}
                            />
                        )}
                        <Truncated
                            type="h1"
                            maxLength={
                                Config.appHeader().appHeaderTitleTruncateLength
                            }
                        >
                            {this.props.pageTitle}
                        </Truncated>
                        {this.props.isShareLink && (
                            <div className={styles.shareLinkLabel}>
                                <span className={styles.shareLinkLabelText}>
                                    Guest View
                                </span>
                            </div>
                        )}
                    </div>
                )}
                {this.props.links.map(link => {
                    const className = [
                        styles.headerLink,
                        link.selected && styles.selected
                    ]
                        .filter(Boolean)
                        .join(" ");
                    return (
                        <Link
                            className={className}
                            to={link.href}
                            key={`header-link-${link.text}`}
                        >
                            {React.createElement(link.icon)}
                            <p>{link.text}</p>
                        </Link>
                    );
                })}
                {this.props.isAuthenticated && (
                    <UserAccountMenu
                        className={[
                            styles.headerLink,
                            styles.userMenu,
                            this.props.myAccountSelected && styles.selected
                        ].join(" ")}
                        user={this.props.user}
                        onMyAccountClick={this.props.onMyAccountClick}
                        logOut={this.props.onLogOutClick}
                    />
                )}
            </div>
        );
    }
}

AppHeader.defaultProps = {
    pageTitle: "",
    pageTitleIcon: "",
    logoLink: "/"
};

AppHeader.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    isShareLink: PropTypes.bool.isRequired,
    user: PropTypes.object,
    team: PropTypes.object,
    pageTitle: PropTypes.string,
    pageTitleIcon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    logoLink: PropTypes.string,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired,
            selected: PropTypes.bool
        })
    ),
    myAccountSelected: PropTypes.bool,
    onMyAccountClick: PropTypes.func.isRequired,
    onLogOutClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/AppHeader/AppHeader.js